import { endpoint } from "@services/api.services";
import { TableCard } from "@ui/internal/components/card";
import { usePathname } from "@utils/hook/index.hook";
import { QueryData } from "@utils/interface/index.interface";
import { useListData } from "@utils/query/index.query";
import { Settings } from "lucide-react";
import React, { useState } from "react";
import { useSearchParams } from "react-router";
import { ColumnList } from "./column/index.column";
import { useMetaStore } from "@utils/states/index.state";
import UserPointsModal from "./_components/UserPointsModal";
import { Button } from "@components/ui/button";
import ManagePoints from "./form/index.form";

type Props = {};
const index: React.FC<Props> = ({}) => {
  const [searchParams] = useSearchParams();
  const pathname = usePathname();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isUserPointsModalOpen, setIsUserPointsModalOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState<any>(null);

  const { search } = useMetaStore();

  const handleOpenUserPoints = (user: any) => {
    setSelectedUser(user);
    setIsUserPointsModalOpen(true);
  };

  const columns = ColumnList({ onView: handleOpenUserPoints });

  /* ================================================= api calls logic ================================================= */
  const { data, refetch, isPending } = useListData<QueryData<any>>({
    params: {
      page: searchParams.get("tpage") || 1,
      size: searchParams.get("per") || 10,
      ordering: searchParams.get("ordering") || "order",
      search: search,
    },
    endpoint: endpoint["cricket-predictions"],
    key: `${pathname}-listing`,
    window: true,
  });

  return (
    <>
      <TableCard
        bulkActions
        table_content={{
          mode: "default",
          type: "user-predictions",
        }}
        inject_ui_table_actions={
          <Button
            className="bg-[#1DA077] hover:bg-[#1DA077]/90 flex gap-2"
            onClick={() => setIsModalOpen(true)}
          >
            <Settings size={16} />
            Manage Points
          </Button>
        }
        orientationPosition={false}
        endpoint={endpoint["cricket-predictions"]}
        refetch={refetch}
        isPending={isPending}
        columns={columns}
        sortableFilter={{
          search: search,
        }}
        hideSort
        rows={data?.data?.results ?? []}
        count={data?.data?.count ?? 10}
        form={<></>}
      />

      {selectedUser && (
        <UserPointsModal
          isOpen={isUserPointsModalOpen}
          onClose={() => setIsUserPointsModalOpen(false)}
          userData={selectedUser}
        />
      )}

      <ManagePoints
        setIsModalOpen={setIsModalOpen}
        refetch={refetch}
        isModalOpen={isModalOpen}
      />
    </>
  );
};

export default index;
